import Duck from 'custom-redux-ducks-ts'

export const favorites = new Duck('favorites', 'eduprivada')
